import React from "react";
import { Link } from 'react-router-dom';

import LogoJFZ_signatureWhite from "../../../assets/jfz-white-transparent.png";

export default function Logout(){

    return(
        <div className="app-container">
            <div className="header login-header-section">Log out</div>
            <div className="nav-bar-container-flex"></div>
            <div className="flex-column-items-center">
                <span className="logout-message">You have been safely Logged Out of the application.</span>               
                <span className="logout-message">You can close the browser or login again.</span>
                <Link to="/public/login" className="btn-element mt-30 btn-w115 btn-h45 pt-12"> Login</Link>  
            </div>
            <div className="bottom flex-column-items-center">               
                <div className="signature-logo">                  
                    <img src={LogoJFZ_signatureWhite}  alt="logo_jfz_signature" className=""/>
                </div>
            </div>           
        </div>
    )
}